export default __webpack_public_path__ + "static/media/5.1da4ff81.jpg";